import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, Subscription, switchMap, timer } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { User } from '../../../core/models/user';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import swal from 'sweetalert2';

export interface iConfirmDetails {
    confirmPersonalDetails: boolean;
    navigateToMihuruUrlForDocsUpload: boolean;
    partnerCallbackUrl: string;
    panid: string;
    pincode: string;
    dob: string;
    // dobui: string;
    gender: string;
    iConfirm: boolean;
}
@Component({
    selector: 'app-assist-confirm-personal-details',
    templateUrl: './assist-confirm-personal-details.component.html',
    styleUrls: ['./assist-confirm-personal-details.component.scss'],
})
export class AssistConfirmPersonalDetailsComponent implements OnInit {
    private timerSubscription: Subscription | undefined;

    private timerKey: string = 'otpTimer';

    @ViewChild('form', { read: NgForm }) form!: NgForm;
    public formReq: iConfirmDetails = {
        confirmPersonalDetails: true,
        navigateToMihuruUrlForDocsUpload: true,
        partnerCallbackUrl: 'www.mihuru.com',
        panid: '',
        pincode: '',
        dob: '',
        // dobui: 'dd-MMM-yyyy',
        gender: 'Choose your gender',
        iConfirm: false,
    };

    public minDate: string;

    public maxDate: string;

    public showConfirmCheckbox: boolean;

    public isCreditMobileNoError: boolean = false;

    public creditMobileNo: string = '';

    public CreditUpdate: FormGroup;

    public CreditUpdateConfirm: FormGroup;

    public creditPopUpErrorMessage: string = '';

    public genderFetched: boolean = false;

    public panFetched: boolean = false;

    public pincodeFetched: boolean = false;

    public dobFetched: boolean = false;

    public showMobileNo: boolean = false;

    public resendAvailable: boolean = false;

    public timeRemaining: number = 60;

    public age: number;
    public maxDobDate: Date;
    public minDobDate: Date;

    public bsConfig: any = {
        dateInputFormat: 'DD-MMM-YYYY',
        showWeekNumbers: false
    };

    constructor(
        private accountService: AccountService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private sessionTimerService: SessionTimerService,
        private datePipe: DatePipe,
        private route: ActivatedRoute,
    ) {
        const today = new Date();
        this.maxDobDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
        this.minDobDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
        this.bsConfig = {
            dateInputFormat: 'DD-MMM-YYYY',
            showWeekNumbers: false,
            maxDate: this.maxDobDate,
            minDate: this.minDobDate
        };

        this.CreditUpdate = new FormGroup({
            mobileNo: new FormControl('')
        });

        this.CreditUpdateConfirm = new FormGroup({
            mobileOTP: new FormControl('')
        })

    }

    public ngOnInit(): void {
        const today = new Date();
        this.maxDobDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
        this.minDobDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
        this.bsConfig = {
            dateInputFormat: 'DD-MMM-YYYY',
            showWeekNumbers: false,
            maxDate: this.maxDobDate,
            minDate: this.minDobDate
        };

        if (this.route.snapshot.queryParamMap.get('t') != null &&
            this.route.snapshot.queryParamMap.get('p') &&
            this.route.snapshot.queryParamMap.get('pi') && this.route.snapshot.queryParamMap.get('g') &&
            this.route.snapshot.queryParamMap.get('d') &&
            this.route.snapshot.queryParamMap.get('m')) {

            const token = this.route.snapshot.queryParamMap.get('t');
            const message = this.route.snapshot.queryParamMap.get('m')
            MemoryStorageService.setItem('customerToken', token);

            const user: User = { token: token, userName: '', email: '', mobileNumber: '' }
            this.accountService.setCurrentUser(user);

            MemoryStorageService.setItem('pan', this.route.snapshot.queryParamMap.get('p'));
            this.formReq.panid = this.route.snapshot.queryParamMap.get('p');
            this.panFetched = true;

            MemoryStorageService.setItem('pincode', this.route.snapshot.queryParamMap.get('pi'));

            this.formReq.pincode = this.route.snapshot.queryParamMap.get('pi');
            this.pincodeFetched = true;

            MemoryStorageService.setItem('dob', this.route.snapshot.queryParamMap.get('d'));
            this.formReq.dob = this.route.snapshot.queryParamMap.get('d');
            // this.formReq.dobui = this.datePipe.transform(this.formReq.dob, 'dd-MMM-yyyy');
            this.dobFetched = true;

            MemoryStorageService.setItem('gender', this.route.snapshot.queryParamMap.get('g'));
            this.formReq.gender = this.route.snapshot.queryParamMap.get('g');
            this.genderFetched = true;

            this.showConfirmCheckbox = false;

            this.openCreditMobileUpdatePopUp(message);

        }
        else {
            const pan = MemoryStorageService.getItem('pan');
            console.log(pan, "pan")

            if (pan && pan != '' && pan !== 'undefined') {
                this.formReq.panid = pan;
                this.panFetched = true;
            }

            const pincode = MemoryStorageService.getItem('pincode');

            if (pincode && pincode != '' && pincode !== 'undefined') {
                this.formReq.pincode = pincode;
                this.pincodeFetched = true;
            }

            const dob = MemoryStorageService.getItem('dob');

            if (dob && dob != '' && dob !== 'undefined') {
                this.formReq.dob = dob;
                // this.formReq.dobui = this.datePipe.transform(this.formReq.dob, 'dd-MMM-yyyy');
                this.dobFetched = true;
            }

            const gender = MemoryStorageService.getItem('gender');

            if (gender && gender != '' && gender !== 'undefined') {
                this.formReq.gender = gender;
                this.genderFetched = true;
            }

            this.showConfirmCheckbox = JSON.parse(MemoryStorageService.getItem('iConfirm'));
        }

        this.calculateAge();


        //Session Timer
        this.sessionTimerService.SetShowTimer(false);
        this.sessionTimerService.stopTimer();
        MemoryStorageService.removeItem('timerEndTime');

        //For OTP Timer
        this.loadTimer();
        this.startTimer();

    }

    public async submit() {
        // Validate PAN
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!this.formReq.panid || !panRegex.test(this.formReq.panid)) {
            swal.fire('Please enter a valid 10-character PAN (e.g. ABCDE1234F).');
            return;
        }

        // Validate DOB & Age
        this.calculateAge();
        if (!this.formReq.dob) {
            swal.fire('Please select your date of birth.');
            return;
        }
        if (this.age === undefined || this.age < 18) {
            swal.fire('You must be at least 18 years old to proceed.');
            return;
        }
        if (this.age > 58) {
            swal.fire('Maximum age allowed is 58 years old.');
            return;
        }

        // Validate Pincode
        const pincodeRegex = /^[0-9]{6}$/;
        if (!this.formReq.pincode || !pincodeRegex.test(this.formReq.pincode)) {
            swal.fire('Please enter a valid 6-digit pin code.');
            return;
        }

        this.spinner.show();

        let formattedDob = this.datePipe.transform(this.formReq.dob, "yyyy-MM-dd");
        if (!formattedDob) {
            const d = new Date(this.formReq.dob);
            if (!isNaN(d.getTime())) {
                formattedDob = this.datePipe.transform(d, "yyyy-MM-dd");
            }
        }

        let generateTravelPlansReq: any = {
            confirmPersonalDetails: true,
            navigateToMihuruUrlForDocsUpload: true,
            partnerCallbackUrl: '',
            panid: this.formReq.panid,
            pincode: this.formReq.pincode,
            dob: formattedDob,
            gender: this.formReq.gender,
        };

        try {
            const response = await firstValueFrom(this.accountService.generateTravelPlans(
                generateTravelPlansReq,
                MemoryStorageService.getItem('customerToken')
            ));

            if (response['error'] && response['error'].hasOwnProperty('errors') && response['errors'].errors.includes('Please provide mobile ending with')) {
                this.openCreditMobileUpdatePopUp(response['error'].errors);
            }

            if (response['data'] == null) {
                this.spinner.hide();
                this.router.navigateByUrl('/assist-journey/sorry');
            }
            MemoryStorageService.setItem(
                'assistTravelPlans',
                JSON.stringify(response['data']['plan_details'])
            );

            if (this.checkPlanEligibility(response['data']['plan_details'])) {
                return this.router.navigateByUrl('/assist-journey/assist-underwrite');
            }


            //starting the Session Timer
            this.sessionTimerService.SetShowTimer(true);
            this.sessionTimerService.startTimer();

            // Setting SessionId to be used on Session Expire Page for updating the apllication Status 
            const user: User = { token: MemoryStorageService.getItem('customerToken'), userName: '', email: '', mobileNumber: '' }
            this.accountService.setCurrentUser(user);
            //////

            //Setting if Available Limit has exhausted 
            // const travelcost = parseInt(MemoryStorageService.getItem('TravelCost'));
            // const availableLimit = parseInt(response['data']['availableLimit']);

            //prajakta removed it, since we are checking this on api side, if available limit < travel cost then no plans will be generated
            //MemoryStorageService.setItem('hasLimitExhausted', travelcost > availableLimit ? "true": "false")
            /////

            /*** skip the plan page with selecting max tenure for all landing page users (TaskId 1073) ***/
            if ((MemoryStorageService.getItem("userSource") === 'LANDING_PAGE' || MemoryStorageService.getItem("userSource") === 'LANDING_PAGE_WIDGET') && response['data']['isFinalPlan'] !== true) {
                const maxTenorPlan = response['data'].plan_details.reduce((max, plan) => {
                    return (plan.tenor > max.tenor) ? plan : max;
                });

                return this.router.navigateByUrl(
                    '/assist-journey/' + maxTenorPlan.navigate_url.split('/')[4]
                );
            }

            /********************/
            this.spinner.hide();
            this.router.navigateByUrl('/assist-journey/payment-plans');

            this.spinner.hide();
        }
        catch (error1) {
            this.spinner.hide();

            if (error1.status === 0) {
                swal.fire("No internet connection. Please check your network and try again.");
                return;
            }

            if (error1['error'] && error1['error'].hasOwnProperty('errors') && error1['error'].errors.includes('Value cannot be null.')) {
                return this.router.navigateByUrl('/assist-journey/session-expired');
            }

            if (error1['error'] && error1['error'].hasOwnProperty('message') && error1['error'].message.includes('Token has expired')) {
                return this.router.navigateByUrl('/assist-journey/session-expired');
            }

            if (error1['error'] && error1['error'].hasOwnProperty('errors') && error1['error'].errors.includes('We are unable to evaluate the user online')) {
                return this.router.navigateByUrl('/assist-journey/assist-underwrite');
            }
            if (error1['error'] && error1['error'].hasOwnProperty('errors') && error1['error'].errors.includes('Please provide mobile ending with')) {
                this.openCreditMobileUpdatePopUp(error1['error'].errors);
                return;
            }
            this.router.navigateByUrl('/assist-journey/sorry');
        }
    }

    public checkPlanEligibility(plans: any[]) {
        const hasEligiblePlan = plans.some(plan => plan.plan_eligibility);
        return !hasEligiblePlan
    }

    public onPanInput(event: any) {
        if (event && event.target) {
            let val = event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
            if (val.length > 10) {
                val = val.substring(0, 10);
            }
            this.formReq.panid = val;
            event.target.value = val;
        }
    }

    public onPincodeInput(event: any) {
        if (event && event.target) {
            let val = event.target.value.replace(/\D/g, '');
            if (val.length > 6) {
                val = val.substring(0, 6);
            }
            this.formReq.pincode = val;
            event.target.value = val;
        }
    }

    public capitalizeInput(fieldName: string) {
        if (this.formReq[fieldName]) {
            this.formReq[fieldName] = this.formReq[fieldName].toUpperCase().trim();
        }
    }

    public openCreditMobileUpdatePopUp(message: string) {

        try {
            this.creditPopUpErrorMessage = message;
            this.creditMobileNo = message.slice(-10);
            console.log(this.creditMobileNo);
        }
        catch (err) { }

        document.getElementById('overlay-credit-phone')!.style.display = 'block';
        document.getElementById('popup-credit-phone')!.style.display = 'block';
        this.showMobileNo = true;
    }

    public calculateAge() {
        if (this.formReq.dob) {
            let birthDate = new Date(this.formReq.dob);
            if (isNaN(birthDate.getTime())) {
                const parts = this.formReq.dob.split(/[-/]/);
                if (parts.length === 3) {
                    if (parts[0].length === 4) {
                        birthDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
                    } else if (parts[2].length === 4) {
                        birthDate = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                    }
                }
            }

            if (!isNaN(birthDate.getTime())) {
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDifference = today.getMonth() - birthDate.getMonth();

                if (
                    monthDifference < 0 ||
                    (monthDifference === 0 && today.getDate() < birthDate.getDate())
                ) {
                    age--;
                }

                this.age = age;
                return;
            }
        }
        this.age = undefined as any;
    }

    public maskValue(value: string, repeatX: number, showChar: number): string {
        if (value.length > repeatX) {
            const firstTwoChars = value.substring(0, showChar);
            const lastTwoChars = value.substring(
                value.length - showChar,
                value.length
            );
            const maskedChars = 'X'.repeat(repeatX);
            return `${firstTwoChars}${maskedChars}${lastTwoChars}`;
        }
        return value; // Return the value as is if it's 4 characters or less
    }
    public allowOnlyNumbers(event: KeyboardEvent) {
        const char = event.key;
        // Allow only numeric input
        if (!char.match(/[0-9]/)) {
            event.preventDefault();
        }
    }


    public async SendAlternativeOTP(mobileNo: string) {
        try {
            this.spinner.show();
            const token = MemoryStorageService.getItem('customerToken');
            MemoryStorageService.setItem("AlternateMobileNo", mobileNo)
            const res = await firstValueFrom(this.accountService.GetOTPForAlternativeNumber(mobileNo, token));
            if (res['error'] == null && res['data'] == 'OTP Sent successfully on given mobile number.') {
                swal.fire("OTP Sent successfully");
                this.showMobileNo = false;
                this.spinner.hide();
                return;
            }
            swal.fire("Could not send OTP! Please try again.");
        }
        catch (err) {
            console.log(err);
            return this.router.navigateByUrl('/assist-journey/session-expired');
        }
        this.spinner.hide();
    }

    public async ConfirmNewNumber(otp: string) {
        try {
            this.spinner.show();
            const token = MemoryStorageService.getItem('customerToken');
            const mobileNo = MemoryStorageService.getItem("AlternateMobileNo")
            const res = await firstValueFrom(this.accountService.UpdateAlternativeNumberForCredit(mobileNo, otp, token));
            if (res['error'] == null) {
                swal.fire("Validation successful");
                this.spinner.hide();
                await this.submit();
                return;
            }
            else if (res['error'] != null && res['error'].response_summary == 'OTP provided is incorrect') {
                swal.fire("OTP provided is incorrect");
            }
            else if (res['error'] != null && res['error'].response_msg == 'Wrong OTP entered thrice. Please generate new OTP.') {
                swal.fire("Wrong OTP entered thrice, Please generate new OTP!");
            }
            else {
                swal.fire("Unable to update mobile number");
            }
        }
        catch (err) {
            console.log(err);
        }
        this.spinner.hide();
    }


    public formatDate(event: any): void {
        if (event) {
            this.formReq.dob = this.datePipe.transform(event, 'dd-MMM-yyyy')!;
            this.calculateAge();
        } else {
            this.formReq.dob = '';
            this.calculateAge();
        }
    }

    public onInputDateChange(event: KeyboardEvent) {
        const key = event.key.toLowerCase();
        if (key !== 'backspace' && key !== 'tab') {
            event.preventDefault();
        }
    }

    /* OTP Timer */
    public startTimer(): void {
        const now = new Date().getTime();
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
        this.timerSubscription = timer(0, 1000).pipe(
            switchMap(() => {
                if (this.timeRemaining > 0) {
                    this.timeRemaining--;
                    this.saveTimer();
                    return [this.timeRemaining];
                } else {
                    this.resendAvailable = true;
                    MemoryStorageService.removeItem(this.timerKey);
                    if (this.timerSubscription) {
                        this.timerSubscription.unsubscribe();
                    }
                    return [];
                }
            })
        ).subscribe();
    }

    public saveTimer(): void {
        const expiryTime = new Date().getTime() + (this.timeRemaining * 1000);
        MemoryStorageService.setItem(this.timerKey, expiryTime.toString());
    }

    public loadTimer(): void {
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const now = new Date().getTime();
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
    }

    public async resendOtp(): Promise<void> {

        this.timeRemaining = 60;
        this.saveTimer();
        this.resendAvailable = false;
        this.startTimer();
        this.spinner.show();
        const token = MemoryStorageService.getItem('customerToken');
        const mobileNo = MemoryStorageService.getItem("AlternateMobileNo")
        const res = await firstValueFrom(this.accountService.GetOTPForAlternativeNumber(mobileNo, token));

        if (res['error'] == null && res['data'] == 'OTP Sent successfully on given mobile number.') {
            swal.fire("OTP Sent successfully");
            this.spinner.hide();
            return;
        }

        swal.fire("Could not send OTP, Please try again!");
    }

    /* End - OTP Timer */
}
